import React from 'react'
import AppDevelopmentTypePage from './AppDevelopmentTypePage'
import { aiTypeContent } from './aiTypeContent'

const AIAppDevelopment = () => <AppDevelopmentTypePage content={aiTypeContent} />

export default AIAppDevelopment
